import React from 'react';
import { Card, Row, Col, Button, Spinner, Badge } from 'react-bootstrap';
import { FaFacebook, FaCheckCircle, FaUnlink, FaPlus, FaSync, FaExclamationTriangle } from 'react-icons/fa';

class ConnectionCard extends React.Component {
  formatExpiryDate = (expiryDate) => {
    if (!expiryDate) return 'N/A';
    const daysLeft = Math.ceil((new Date(expiryDate) - new Date()) / (1000 * 60 * 60 * 24));
    if (daysLeft < 0) return 'Expired';
    if (daysLeft < 7) return `${daysLeft} days left (expiring soon)`;
    return `${daysLeft} days left`;
  };

  render() {
    const { status, info, onConnect, tokenExpiry, inApiCall, onRefresh, onDisconnect, configLoaded } = this.props;
    const isConn = status === 'connected';
    const isExpired = status === 'expired';

    return (
      <>
        <div style={{ padding: '24px', borderBottom: '1px solid #edf2f9' }}>
          <Row>
            <Col md={8}>
              <h2 style={{ margin: 0, fontWeight: '600', fontSize: '28px' }}>
                <FaFacebook style={{ marginRight: '12px' }} /> Facebook Integration
              </h2>
              <p style={{ margin: '8px 0 0 0', opacity: 0.9 }}>Connect once, add multiple forms without reconnecting</p>
            </Col>
            <Col md={4} style={{ textAlign: 'right' }}>
              <Badge style={{
                background: isConn ? 'rgba(6,214,160,0.2)' : isExpired ? 'rgba(255,193,7,0.2)' : 'rgba(239,71,111,0.2)',
                color: isConn ? '#06d6a0' : isExpired ? '#b8860b' : '#ef476f',
                padding: '8px 16px', borderRadius: '50px', fontSize: '14px',
                border: isConn ? '1px solid #06d6a0' : isExpired ? '1px solid #b8860b' : '1px solid #ef476f'
              }}>
                {isConn ? 'Connected' : isExpired ? 'Reconnect Required' : 'Disconnected'}
              </Badge>
            </Col>
          </Row>
        </div>

        {/* Connection Status Card */}
        <div style={{ padding: '24px', background: '#ffffff', borderBottom: '1px solid #edf2f9' }}>
          <Card style={{ background: isConn ? 'linear-gradient(135deg, #f0f7ff 0%, #e6f7ff 100%)' : '#f8f9fa', border: isConn ? `2px solid #28a745` : `2px dashed #6c757d`, borderRadius: '16px' }}>
            <Card.Body>
              <Row>
                <Col md={8}>
                  <h5 style={{ marginBottom: '12px', fontWeight: '600' }}>
                    { isExpired
                      ? <><FaExclamationTriangle color="#b8860b" style={{ marginRight: '8px' }} /> Token Expired — Reconnect Required</>
                      : isConn ? <><FaCheckCircle color="#28a745" style={{ marginRight: '8px' }} /> Facebook Account Connected</> : <><FaUnlink color="#6c757d" style={{ marginRight: '8px' }} /> Not Connected</>
                    }
                  </h5>
                  {isConn && info && (
                    <div>
                      <p style={{ margin: '4px 0' }}><strong>Account:</strong> {info.facebook_user?.name || 'Connected'}</p>
                      <p style={{ margin: '4px 0' }}><strong>Token expires:</strong> {this.formatExpiryDate(tokenExpiry)}</p>
                    </div>
                  )}
                  {!isConn && <p style={{ color: '#6c757d', margin: '8px 0 0 0' }}>Connect your Facebook account once to start adding forms</p>}
                </Col>
                <Col md={4} style={{ textAlign: 'right' }}>
                  { isExpired ? (
                    <>
                      <Button variant="warning" onClick={onConnect} disabled={inApiCall || !configLoaded} style={{ borderRadius: '50px', padding: '10px 24px' }}>
                        <FaSync style={{ marginRight: '8px' }} /> Reconnect Facebook
                      </Button>
                      <Button variant="outline-danger" onClick={() => onDisconnect(info?.integration_id, info?.account_name)} disabled={inApiCall} style={{ borderRadius: '50px', padding: '8px 16px', marginLeft: '8px' }}><FaUnlink /></Button>
                    </>
                  ) : isConn ? (
                    <>
                      <Button variant="outline-secondary" onClick={onRefresh} disabled={inApiCall} style={{ borderRadius: '50px', padding: '8px 16px' }}><FaSync /> Refresh Token</Button>
                      <Button variant="outline-danger" onClick={() => onDisconnect(info?.integration_id, info?.account_name)} disabled={inApiCall} style={{ borderRadius: '50px', padding: '8px 16px', marginLeft: '8px' }}><FaUnlink /></Button>
                    </>
                  ) : (
                    <Button variant="primary" onClick={onConnect} disabled={inApiCall || !configLoaded} style={{ borderRadius: '50px', padding: '10px 24px' }}>
                      {inApiCall ? <><Spinner animation="border" size="sm" style={{ marginRight: '8px' }} /> Connecting...</> : <><FaFacebook style={{ marginRight: '8px' }} /> Connect Facebook Account</>}
                    </Button>
                  )}
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </div>
      </>
    );
  }
}
export default ConnectionCard;